import OutgoingDocumentsForm from "./OutgoingDocumentsForm";

export default OutgoingDocumentsForm;
